import { render, staticRenderFns } from "./WelcomeCustom.vue?vue&type=template&id=78e1a2ee&scoped=true&"
import script from "./WelcomeCustom.vue?vue&type=script&lang=js&"
export * from "./WelcomeCustom.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeCustom.vue?vue&type=style&index=0&id=78e1a2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e1a2ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VCol,VContainer,VRow,VSheet})
